import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { gameRegistry } from '../exercises-engine/gameTypes/registry';
import { useAuth } from '../auth/AuthContext';
import { getCvInputs } from '../lib/cortivoxApi';

/**
 * Тренажёр. CV-модуль работает в report_mode="client": своих данных о
 * пользователе у него нет. Пациенту, вошедшему в систему, мы отдаём его
 * калибровку и пороги из прошлых отчётов (cvInputs) и его id (userId): по
 * нему CV-сервер сам присылает отчёт на наш сервер (POST
 * /api/cv-reports/server). Гость и врач занимаются без сохранения.
 */
export default function ExerciseRunnerPage() {
  const { exerciseId } = useParams();
  const navigate = useNavigate();
  const { doctor: profile, loading } = useAuth();

  const exercise = gameRegistry[exerciseId];
  const slug = exercise?.exerciseConfig.slug;
  const patientId = profile?.role === 'patient' ? profile.id : null;

  // undefined — ещё не решили (ждём вход или ответ API); null — без входных данных.
  const [cvInputs, setCvInputs] = useState(undefined);
  useEffect(() => {
    if (!slug || loading) return undefined;
    if (!patientId) {
      setCvInputs(null);
      return undefined;
    }
    let cancelled = false;
    getCvInputs({ exerciseSlug: slug })
      .then((inputs) => { if (!cancelled) setCvInputs(inputs); })
      .catch((error) => {
        console.warn('[exercise] настройки упражнения не загрузились, занимаемся без них:', error);
        if (!cancelled) setCvInputs(null);
      });
    return () => { cancelled = true; };
  }, [slug, loading, patientId]);

  if (!exercise) {
    return (
      <div className="h-screen flex flex-col items-center justify-center gap-4">
        <p className="text-2xl text-muted-foreground">Упражнение не найдено</p>
        <button onClick={() => navigate('/patient')} className="bg-primary text-white px-6 py-3 rounded-xl">Вернуться назад</button>
      </div>
    );
  }

  if (cvInputs === undefined) {
    return <div className="h-screen flex items-center justify-center text-muted-foreground">Загрузка…</div>;
  }

  const GameComponent = exercise.View;
  return (
    <GameComponent
      exerciseConfig={exercise.exerciseConfig}
      userId={patientId}
      cvInputs={cvInputs}
      onComplete={() => navigate('/patient')}
    />
  );
}
